<template>
  <!--start customers-->
  <section class="customers">
    <DataTable
      :value="customers"
      v-if="error == false"
      :paginator="true"
      :rowsPerPageOptions="[10, 20, 30, 40]"
      :rows="10"
      :loading="loading"
      ref="dt"
      :lazy="true"
      :totalRecords="total"
      @page="onPage($event)"
      @sort="onPage($event)"
    >
      <Column field="customer_name" header="Customer Name">
        <template #body="slotProps">
          <a href="#" class="view_customer">
            <h4>
              {{
                slotProps.data.customer_name
                  ? slotProps.data.customer_name
                  : "anonymous"
              }}
            </h4>
          </a>
        </template>
      </Column>

      <Column field="counter" header="No. of items in list"></Column>
      <Column field="updated_at" header="Last Wishlist Addition On"> </Column>
    </DataTable>

    <section class="empty" v-if="error">
      <img src="../assets/images/icons/empty.svg" alt="" srcset="" />
      <h4>Empty Customers</h4>
      <p>You’ve not added any Customers</p>
    </section>
  </section>
</template>

<script>
import { ref } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import wishListsService from "../services/wishlists.js";

export default {
  name: "customersComponent",

  setup() {
    const customers = ref([]);
    const wishlistService = new wishListsService();
    const lazyParams = {
      first: 0,
      sortField: null,
      sortOrder: null,
    };
    const total = ref(0);
    const error = ref(false);
    const loading = ref(true);
    return {
      customers,
      wishlistService,
      lazyParams,
      total,
      error,
      loading,
    };
  },
  components: {
    DataTable,
    Column,
  },
  mounted() {
    this.loadLazyData();
    this.$emit("name", "Customers");
  },
  methods: {
    loadLazyData() {
      this.wishlistService.getTotalCustomers(this.lazyParams).then((data) => {
        this.loading = false;
        if (data.success) {
          this.total = data.payload.total;
          this.customers = data.payload.data;
        } else {
          this.error = true;
        }
      });
    },
    onPage(data) {
      this.lazyParams = data;
      this.loadLazyData();
    },

    redirect(link) {
      window.parent.location.href = `https://admin.lexmodo.com/customers/${link}`;
    },
  },
};
</script>

<style lang="scss">
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 140px 0;
  width: 100%;
  background-color: #fff;
}
.empty img {
  margin-bottom: 20px;
}
.empty h4 {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 7px;
}
.empty p {
  font-size: 14px;
  font-weight: 400;
  color: #6d6d6d;
}
.customers {
  // start view_customer
  .view_customer {
    display: flex;
    align-items: center;
    font-weight: 15px;
    font-size: 14px;
    font-weight: 400;
    gap: 25px;
    img {
      width: 62px;
      height: 62px;
    }
  }
  // start view-item
  .view-item {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    gap: 10px;
    color: #1575bf;
    background-color: #fff;
    border: none;
  }
}
.p-paginator {
  display: flex;
  justify-content: flex-end;
}
</style>
